module.exports = __webpack_public_path__ + "media/images/hitfun3/bg.maincol-ea185373f73e2f1819df1a11e306fc9b.svg";